import { LOCAL_AGENT_TOOL_ACTIVITY_NAMES } from "@wakeloop/schemas";
export const ADAPTER_TOOL_ACTIVITY_NAMES = LOCAL_AGENT_TOOL_ACTIVITY_NAMES;
const COMMAND_TOOL_NAMES = new Set([
    "bash",
    "command",
    "commandexecution",
    "command_execution",
    "shell",
]);
const READ_TOOL_NAMES = new Set(["read", "readfile", "read_file"]);
const EDIT_TOOL_NAMES = new Set([
    "edit",
    "filechange",
    "file_change",
    "multiedit",
    "notebookedit",
    "notebook_edit",
    "write",
    "writefile",
    "write_file",
]);
const FILE_SEARCH_TOOL_NAMES = new Set([
    "glob",
    "grep",
    "searchfiles",
    "search_files",
]);
const WEB_SEARCH_TOOL_NAMES = new Set([
    "websearch",
    "web_search",
    "web_search_20250305",
    "web_search_20260209",
]);
const WEB_FETCH_TOOL_NAMES = new Set([
    "webfetch",
    "web_fetch",
    "web_fetch_20250910",
    "web_fetch_20260209",
    "web_fetch_20260309",
]);
const DELEGATION_TOOL_NAMES = new Set([
    "agent",
    "collabagenttoolcall",
    "collab_agent_tool_call",
    "task",
]);
const IMAGE_TOOL_NAMES = new Set([
    "imagegeneration",
    "image_generation",
    "imageview",
    "image_view",
]);
export function resolveAdapterToolActivityName(providerToolName) {
    const normalized = normalizeProviderToolName(providerToolName);
    if (COMMAND_TOOL_NAMES.has(normalized)) {
        return "agent_run_command";
    }
    if (READ_TOOL_NAMES.has(normalized)) {
        return "agent_read_files";
    }
    if (EDIT_TOOL_NAMES.has(normalized)) {
        return "agent_edit_files";
    }
    if (FILE_SEARCH_TOOL_NAMES.has(normalized)) {
        return "agent_search_files";
    }
    if (WEB_SEARCH_TOOL_NAMES.has(normalized)) {
        return "agent_search_web";
    }
    if (WEB_FETCH_TOOL_NAMES.has(normalized)) {
        return "agent_open_webpage";
    }
    if (DELEGATION_TOOL_NAMES.has(normalized)) {
        return "agent_delegate_task";
    }
    if (IMAGE_TOOL_NAMES.has(normalized)) {
        return "agent_work_with_image";
    }
    return "agent_use_tool";
}
function normalizeProviderToolName(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
}
